import { createAction } from "redux-act";

// Fetch List
const FETCH_STEERING_DATA_LIST = "FETCH_STEERING_DATA_LIST";
const FETCH_STEERING_DATA_LIST_SUCCESS = "FETCH_STEERING_DATA_LIST_SUCCESS";
const FETCH_STEERING_DATA_LIST_FAILED = "FETCH_STEERING_DATA_LIST_FAILED";

// Fetch Single Record
const FETCH_STEERING_DATA_RECORD = "FETCH_STEERING_DATA_RECORD";
const FETCH_STEERING_DATA_RECORD_SUCCESS = "FETCH_STEERING_DATA_RECORD_SUCCESS";
const FETCH_STEERING_DATA_RECORD_FAILED = "FETCH_STEERING_DATA_RECORD_FAILED";

// Create
const CREATE_STEERING_DATA = "CREATE_STEERING_DATA";
const CREATE_STEERING_DATA_SUCCESS = "CREATE_STEERING_DATA_SUCCESS";
const CREATE_STEERING_DATA_FAILED = "CREATE_STEERING_DATA_FAILED";

// Create Batch
const CREATE_STEERING_DATA_BATCH = "CREATE_STEERING_DATA_BATCH";
const CREATE_STEERING_DATA_BATCH_SUCCESS = "CREATE_STEERING_DATA_BATCH_SUCCESS";
const CREATE_STEERING_DATA_BATCH_FAILED = "CREATE_STEERING_DATA_BATCH_FAILED";

// Update
const UPDATE_STEERING_DATA = "UPDATE_STEERING_DATA";
const UPDATE_STEERING_DATA_SUCCESS = "UPDATE_STEERING_DATA_SUCCESS";
const UPDATE_STEERING_DATA_FAILED = "UPDATE_STEERING_DATA_FAILED";

// Delete
const DELETE_STEERING_DATA = "DELETE_STEERING_DATA";
const DELETE_STEERING_DATA_SUCCESS = "DELETE_STEERING_DATA_SUCCESS";
const DELETE_STEERING_DATA_FAILED = "DELETE_STEERING_DATA_FAILED";

// Fetch Children (hidden per-file rows of a url-files parent)
const FETCH_STEERING_DATA_CHILDREN = "FETCH_STEERING_DATA_CHILDREN";
const FETCH_STEERING_DATA_CHILDREN_SUCCESS = "FETCH_STEERING_DATA_CHILDREN_SUCCESS";
const FETCH_STEERING_DATA_CHILDREN_FAILED = "FETCH_STEERING_DATA_CHILDREN_FAILED";

// Delete a single child of a url-files parent
const DELETE_STEERING_DATA_CHILD = "DELETE_STEERING_DATA_CHILD";
const DELETE_STEERING_DATA_CHILD_SUCCESS = "DELETE_STEERING_DATA_CHILD_SUCCESS";
const DELETE_STEERING_DATA_CHILD_FAILED = "DELETE_STEERING_DATA_CHILD_FAILED";

// Real-time status update (from IoT messaging)
const UPDATE_STEERING_DATA_STATUS = "UPDATE_STEERING_DATA_STATUS";

// Loading / Error
const SET_STEERING_DATA_LOADING = "SET_STEERING_DATA_LOADING";
const SET_STEERING_DATA_ERROR = "SET_STEERING_DATA_ERROR";

// Fetch List. Pass { silent: true } to refresh without toggling the page loader
// (used by real-time list-changed updates so the grid updates smoothly).
export const fetchSteeringDataList = createAction(
    FETCH_STEERING_DATA_LIST,
    (payload?: { silent?: boolean }) => payload
);
export const fetchSteeringDataListSuccess = createAction(
    FETCH_STEERING_DATA_LIST_SUCCESS,
    (payload) => payload
);
export const fetchSteeringDataListFailed = createAction(
    FETCH_STEERING_DATA_LIST_FAILED,
    (payload) => payload
);

// Fetch Single Record
export const fetchSteeringDataRecord = createAction(FETCH_STEERING_DATA_RECORD);
export const fetchSteeringDataRecordSuccess = createAction(
    FETCH_STEERING_DATA_RECORD_SUCCESS,
    (payload) => payload
);
export const fetchSteeringDataRecordFailed = createAction(
    FETCH_STEERING_DATA_RECORD_FAILED,
    (payload) => payload
);

// Create
export const createSteeringData = createAction(CREATE_STEERING_DATA, (payload) => payload);
export const createSteeringDataSuccess = createAction(
    CREATE_STEERING_DATA_SUCCESS,
    (payload) => payload
);
export const createSteeringDataFailed = createAction(
    CREATE_STEERING_DATA_FAILED,
    (payload) => payload
);

// Create Batch
export const createSteeringDataBatch = createAction(
    CREATE_STEERING_DATA_BATCH,
    (payload) => payload
);
export const createSteeringDataBatchSuccess = createAction(
    CREATE_STEERING_DATA_BATCH_SUCCESS,
    (payload) => payload
);
export const createSteeringDataBatchFailed = createAction(
    CREATE_STEERING_DATA_BATCH_FAILED,
    (payload) => payload
);

// Update
export const updateSteeringData = createAction(UPDATE_STEERING_DATA, (payload) => payload);
export const updateSteeringDataSuccess = createAction(
    UPDATE_STEERING_DATA_SUCCESS,
    (payload) => payload
);
export const updateSteeringDataFailed = createAction(
    UPDATE_STEERING_DATA_FAILED,
    (payload) => payload
);

// Delete
export const deleteSteeringData = createAction(DELETE_STEERING_DATA, (payload) => payload);
export const deleteSteeringDataSuccess = createAction(
    DELETE_STEERING_DATA_SUCCESS,
    (payload) => payload
);
export const deleteSteeringDataFailed = createAction(
    DELETE_STEERING_DATA_FAILED,
    (payload) => payload
);

// Fetch Children — payload is the parent steeringDataGuid.
export const fetchSteeringDataChildren = createAction(
    FETCH_STEERING_DATA_CHILDREN,
    (parentGuid: string) => parentGuid
);
export const fetchSteeringDataChildrenSuccess = createAction(
    FETCH_STEERING_DATA_CHILDREN_SUCCESS,
    (payload: { parentGuid: string; children: any[] }) => payload
);
export const fetchSteeringDataChildrenFailed = createAction(
    FETCH_STEERING_DATA_CHILDREN_FAILED,
    (payload: { parentGuid: string; error: string }) => payload
);

// Delete Child — payload is { parentGuid, childGuid }.
export const deleteSteeringDataChild = createAction(
    DELETE_STEERING_DATA_CHILD,
    (payload: { parentGuid: string; childGuid: string }) => payload
);
export const deleteSteeringDataChildSuccess = createAction(
    DELETE_STEERING_DATA_CHILD_SUCCESS,
    (payload: { parentGuid: string; childGuid: string }) => payload
);
export const deleteSteeringDataChildFailed = createAction(
    DELETE_STEERING_DATA_CHILD_FAILED,
    (payload: { parentGuid: string; error: string }) => payload
);

// Real-time status update (from IoT messaging)
export const updateSteeringDataStatus = createAction(
    UPDATE_STEERING_DATA_STATUS,
    (payload) => payload
);

// Loading / Error
export const setSteeringDataLoading = createAction(
    SET_STEERING_DATA_LOADING,
    (payload: boolean) => payload
);
export const setSteeringDataError = createAction(
    SET_STEERING_DATA_ERROR,
    (payload: string | null) => payload
);
